export const parseCookieStrToObject = (cookie: string) =>
    cookie?.split('; ')?.reduce((prev, current) => {
        const [name, ...value] = current.split('=');
        (prev as any)[name] = value.join('=');

        return prev;
    }, {});
